export default "__VITE_ASSET__CfhlL$5p__"